import { FC } from "react";

import { useTheme } from "@mui/material";
import { hexToRgb } from "@simplyk/common";

import { DashboardIconButton, DashboardIconButtonProps } from "@/dashboard-design-system/IconButton";
import { mergeSx } from "@/helpers/mergeSx";
import { Cross } from "@/icons/outlined";

type CloseDialogButtonProps = Omit<DashboardIconButtonProps, "icon" | "data-test" | "children" | "vibe" | "variant">;

export const CloseDialogButton: FC<CloseDialogButtonProps> = ({ sx, ...rest }) => {
  const theme = useTheme();

  const hoverColorRgb = hexToRgb(theme.palette.surface.neutral.moderate);

  const styles = mergeSx(
    {
      color: theme.palette.text.reverse.intense,
      ["&:hover"]: {
        backgroundColor: `rgba(${hoverColorRgb?.r}, ${hoverColorRgb?.g}, ${hoverColorRgb?.b}, 0.2)`,
        color: theme.palette.text.reverse.intense,
      },
    },
    sx
  );

  return (
    <DashboardIconButton {...rest} variant="text" vibe="neutral" data-test="share-form-modal-close-button" sx={styles}>
      <Cross />
    </DashboardIconButton>
  );
};
